import './equipment.sass'